if (!customElements.get("event-flash-sale")) {
    class EventFlashSale extends HTMLElement {
        constructor() {
            super();
            this.pcNumber = parseInt(this.dataset.hidePc, 10);
            this.mbNumber = parseInt(this.dataset.hideMb, 10);
            this.itemContainer = this.querySelector('.event-flash-sale__container');
            this.items = Array.from(this.itemContainer.querySelectorAll('.event-flash-sale__item'));
            this.button = this.querySelector('.event-flash-sale__view-more');
        }

        connectedCallback() {
            const isMobile = window.matchMedia('(max-width: 1000px)').matches;
            const hideNumber = isMobile ? this.mbNumber : this.pcNumber;

            if (this.items.length > hideNumber) {
                this.hideItems(hideNumber);
                if (this.button) {
                    this.setAttribute('data-show-button', "true");
                    this.button.addEventListener('click', this.showItems.bind(this));
                }
            }
        }

        hideItems(number) {
            this.items.slice(number).forEach(item => item.style.display = 'none');
        }

        showItems() {
            this.items.forEach(item => item.style.removeProperty('display'));
            this.setAttribute('data-button-clicked', "true");
        }
    }

    customElements.define('event-flash-sale', EventFlashSale);
}
